import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { registerUser } from "../../firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import { db } from "../../firebase/config";
// import { auth } from "../../firebase/config";
import { sendEmailVerification } from "firebase/auth";
import { FaGift, FaCreditCard } from "react-icons/fa";
// import logoo from "../../assets/images/gymfithorlogo2-removebg-preview.png";
import logoo from "../../assets/images/gymfitorangelogo22.png";
import registerimage2 from "../../assets/images/registerimage2.png";
import { FaEye, FaEyeSlash } from "react-icons/fa";

import {
  FaDumbbell,
  FaUser,
  FaPhone,
  FaEnvelope,
  FaLock,
} from "react-icons/fa";

import "./Register.css";

export default function Register() {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  const [formData, setFormData] = useState({
    gymName: "",
    ownerName: "",
    phone: "",
    email: "",
    password: "",
    registrationType: "trial",
    termsAgreement: false,
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    if (!formData.termsAgreement) {
      alert("Please agree to the Terms & Conditions and Privacy Policy.");
      return;
    }
    // Gym Name
    if (!formData.gymName.trim()) {
      alert("Please enter your gym name.");
      return;
    }

    // Owner Name
    if (!formData.ownerName.trim()) {
      alert("Please enter the owner name.");
      return;
    }

    // Phone Number
    const phoneRegex = /^[6-9]\d{9}$/;

    if (!phoneRegex.test(formData.phone)) {
      alert("Please enter a valid 10-digit mobile number.");
      return;
    }

    // Email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(formData.email)) {
      alert("Please enter a valid email address.");
      return;
    }

    // Password
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#!])[A-Za-z\d@$!%*?&#!]{8,}$/;

    if (!passwordRegex.test(formData.password)) {
      alert(
        "Password must be at least 8 characters and contain an uppercase letter, lowercase letter, number, and special character.",
      );
      return;
    }

    try {
      const userCredential = await registerUser(
        formData.email,
        formData.password,
      );

      await sendEmailVerification(userCredential.user);

      const uid = userCredential.user.uid;

      await setDoc(doc(db, "gyms", uid), {
        gymName: formData.gymName,
        ownerName: formData.ownerName,
        phone: formData.phone,
        email: formData.email,

        registrationType: formData.registrationType,

        status: "Pending",

        subscriptionPlan: null,

        subscriptionStatus: "Inactive",

        subscriptionStartDate: null,

        subscriptionEndDate: null,

        paymentStatus: null,

        paymentDone: false,

        trialUsed: false,

        createdAt: new Date().toISOString(),
      });

      alert(
        "Registration Successful. Please verify your email before logging in.",
      );

      navigate("/verify-email");
    } catch (error) {
      console.error(error);
      alert(error.message);
    }
  };

  return (
    <div className="register-container">
      {/* <div className="register-banner">
        <div className="banner-content">
          <h1>Start Growing Your Gym Business</h1>

          <p>
            Manage Members, Trainers, Attendance, Payments and Subscriptions
            from a single platform.
          </p>

          <img src={registerimage2} alt="gym" />
        </div>
      </div> */}
      <div
        className="register-banner"
        style={{
          backgroundImage: `url(${registerimage2})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="register-overlay"></div>

        <div className="register-content">
          <h1>Build the Future of Your Fitness Business</h1>

          <p>
            Everything you need to manage members, trainers, attendance,
            subscriptions, billing and reports from one intelligent platform.
          </p>

          <div className="banner-buttons">
            {/* <button>AI Powered</button> */}
            <Link to="/">
              <button>Landing Page</button>
            </Link>
            <button>Cloud Based</button>
            <button>Secure & Fast</button>
          </div>
        </div>
      </div>

      <div className="register-form-section">
        <div className="register-card">
          <div className="register-logo">
            <img src={logoo} alt="logo" className="logocss" />
            <p className="logopara">Smart Gym & Fitness Management Software</p>
          </div>

          <h2>Create Gym Account</h2>

          <form onSubmit={handleRegister}>
            <div className="input-group">
              <FaDumbbell className="input-icon" />
              <input
                type="text"
                name="gymName"
                placeholder="Gym Name"
                value={formData.gymName}
                onChange={handleChange}
                required
              />
            </div>

            <div className="input-group">
              <FaUser className="input-icon" />
              <input
                type="text"
                name="ownerName"
                placeholder="Owner Name"
                value={formData.ownerName}
                onChange={handleChange}
                required
              />
            </div>

            <div className="input-group">
              <FaPhone className="input-icon" />
              <input
                type="text"
                name="phone"
                placeholder="Phone Number"
                value={formData.phone}
                onChange={handleChange}
                required
                maxLength={10}
              />
            </div>

            <div className="input-group">
              <FaEnvelope className="input-icon" />
              <input
                type="email"
                name="email"
                placeholder="Email Address"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="input-group">
              <FaLock className="input-icon" />

              <input
                type={showPassword ? "text" : "password"}
                name="password"
                placeholder="Password"
                value={formData.password}
                onChange={handleChange}
                required
                minLength={8}
              />

              <button
                type="button"
                className="password-toggle"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>

            <p
              style={{
                fontSize: "12px",
                color: "#777",
                marginTop: "6px",
                lineHeight: "1.5",
              }}
            >
              Password must contain:
              <br />
              • Minimum 8 characters
              <br />
              • One uppercase letter (A-Z)
              <br />
              • One lowercase letter (a-z)
              <br />
              • One number (0-9)
              <br />• One special character (@, #, $, %, &, !)
            </p>
            <div className="registration-type">
              <h3>Choose Registration Type</h3>

              <label
                className={`registration-card ${
                  formData.registrationType === "trial" ? "active" : ""
                }`}
              >
                <input
                  type="radio"
                  name="registrationType"
                  value="trial"
                  checked={formData.registrationType === "trial"}
                  onChange={handleChange}
                />

                <div className="registration-content">
                  <FaGift className="registration-icon trial-icon" />

                  <div>
                    <h4>Free 1-Day Trial</h4>
                    <p>Explore all premium features for 1 day at no cost.</p>
                  </div>
                </div>
              </label>

              <label
                className={`registration-card ${
                  formData.registrationType === "paid" ? "active" : ""
                }`}
              >
                <input
                  type="radio"
                  name="registrationType"
                  value="paid"
                  checked={formData.registrationType === "paid"}
                  onChange={handleChange}
                />

                <div className="registration-content">
                  <FaCreditCard className="registration-icon paid-icon" />

                  <div>
                    <h4>Buy Subscription</h4>
                    <p>Start immediately with a paid plan after approval.</p>
                  </div>
                </div>
              </label>
            </div>

            {/* <button type="submit">Create Account</button> */}
            <div className="terms-checkbox">
              <input
                type="checkbox"
                id="termsAgreement"
                name="termsAgreement"
                checked={formData.termsAgreement}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    termsAgreement: e.target.checked,
                  })
                }
              />

              <label htmlFor="termsAgreement">
                I agree to the{" "}
                <a
                  href="/terms-and-conditions"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Terms & Conditions
                </a>{" "}
                and{" "}
                <a
                  href="/privacy-policy"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Privacy Policy
                </a>
              </label>
            </div>

            <button
              type="submit"
              disabled={!formData.termsAgreement}
              className="register-submit-btn"
            >
              Create Account
            </button>
          </form>

          <p className="login-link">
            Already have an account?
            <Link to="/login">Login</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
